import { render, staticRenderFns } from "./DashboardGraph.vue?vue&type=template&id=0b0261cb&scoped=true&"
import script from "./DashboardGraph.vue?vue&type=script&lang=js&"
export * from "./DashboardGraph.vue?vue&type=script&lang=js&"
import style0 from "./DashboardGraph.vue?vue&type=style&index=0&id=0b0261cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0261cb",
  null
  
)

export default component.exports